module.exports = __webpack_public_path__ + "static/img/mask_wx.8ed2b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mask_wx.png
// module id = BX5G
// module chunks = 39